// extracted by mini-css-extract-plugin
export default {"reviews":"gw","yotpo":"hw","wrapper":"iw","review_list":"jw","carousel":"kw","swiper-slide":"lw","review":"mw","title":"nw","verified":"ow"};
    if(module.hot) {
      // 1711394576402
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  